/**
 * Public-facing product naming — hides the internal technology stack
 * (Kamailio / FreeSWITCH / CGRates) from platform users.
 *
 * Internal identifiers (server_type enums, config keys, API paths)
 * remain unchanged; only DISPLAY strings are mapped here.
 */
export const BRAND = {
  productName: "Softswitch Control Plane",
  // Role labels shown in the UI instead of technology names
  roles: {
    kamailio: "Session Border / Routing",
    freeswitch: "Media & Call Handling",
    cgrates: "Billing Engine",
  },
  // Files/attachments downloaded by users
  rateDeckLabel: "Price List",
};

/** Map a server_type (kamailio|freeswitch|cgrates) to its public role name. */
export function publicRoleName(serverType: string): string {
  const key = serverType.toLowerCase().replace("freeswitch", "freeswitch");
  return (BRAND.roles as Record<string, string>)[key] || serverType;
}
